/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data format is accepted?`)
};

const es_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué formato de datos se acepta?`)
};

const de_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Datenformat wird akzeptiert?`)
};

const nl_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk gegevensformaat wordt geaccepteerd?`)
};

const fr_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel format de données est accepté ?`)
};

const it_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che formato di dati è accettato?`)
};

const pt_br2_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que formato de dados é aceito?`)
};

const pt_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que formato de dados é aceite?`)
};

const ja_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのようなデータ形式に対応していますか？`)
};

const zh_area_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受什么数据格式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_faq_q3", locale)
	if (locale === "en") return en_area_faq_q3(inputs)
	if (locale === "es") return es_area_faq_q3(inputs)
	if (locale === "de") return de_area_faq_q3(inputs)
	if (locale === "nl") return nl_area_faq_q3(inputs)
	if (locale === "fr") return fr_area_faq_q3(inputs)
	if (locale === "it") return it_area_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_area_faq_q3(inputs)
	if (locale === "pt") return pt_area_faq_q3(inputs)
	if (locale === "ja") return ja_area_faq_q3(inputs)
	return zh_area_faq_q3(inputs)
};